import { Navigate } from "react-router-dom";

export default function DowntimeReportRedirect() {
  return <Navigate to="/reports/downtime/trend" replace />;
}
